module.exports = __webpack_public_path__ + "img/U2601.95d09d71.png";